import { Grid, IconButton, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import { usePallet } from "../../../../contexts/PalletContext";
import legis_agenda from "../../../../img/logo_legis_alta.png";
import PrintIcon from '@mui/icons-material/Print';
import { isMobile} from 'react-device-detect';
import legis_agenda2 from "../../../../img/legis_agenda2.png";
import RelatorioService from "../../../../services/RelatoriosService";
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import { useQuery } from '../../../../utils/utils';
import CircularLoading from '../../../../components/CircularLoading';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';


export default function RelatorioProposicoesDivididasPorTemasLegislativos() {
    const { pallet } = usePallet();
    const { dtIni } = useParams() as any;
    const { dtFin } = useParams() as any;
    const [loading, setLoading] = useState(true)

    let filter = useQuery().get('filter');
    const [filtro, setFiltro] = useState(filter)
    const [dataCD, setDataCD] = useState([])
    const [dataSF, setDataSF] = useState([])
    const [dataCN, setDataCN] = useState([])

    let totalGeralCD = 0;
    const[totalForaMapCD,setTotalForaMapCD] = useState(0);
    let totalGeralSF = 0;
    const[totalForaMapSF,setTotalForaMapSF] = useState(0);
    let totalGeralCN = 0;
    const[totalForaMapCN,setTotalForaMapCN] = useState(0);

    let esferaTipo = filter.substring(27, 29)

    const Imprimir = () => {
        window.print()
    }

    React.useEffect(() => {
        setLoading(true)

        if (
            String(format(new Date(dtIni), "yyyy")).slice(0, 1) !== "0" &&
            String(format(new Date(dtFin), "yyyy")).slice(0, 1) !== "0"
        ) {
            RelatorioService.GetProposicoesDivididaCasaTemaLegislativo(
                format(new Date(dtIni), "yyyy-MM-dd"),
                format(new Date(dtFin), "yyyy-MM-dd 23:59:00.000"),
                String(filtro)
            ).then(async res => {

                await setDataCD(res?.data?.casasTemas?.proposicoesTemasCamara)
                await setDataSF(res?.data?.casasTemas?.proposicoesTemasSenado)
                await setDataCN(res?.data?.casasTemas?.proposicoesTemasCongresso)
  
                // setTimeout(() => {
                await setLoading(false)
                // }, 500);
            })
        }
    }, []);


    React.useEffect(() => {

        dataCD?.map(x => {
                
            totalGeralCD +=  Number(x.count) 
            

            setTotalForaMapCD(totalGeralCD)

        })
    }, [dataCD]);


    React.useEffect(() => {

        dataSF?.map(x => {
                
            totalGeralSF +=  Number(x.count) 
            

            setTotalForaMapSF(totalGeralSF)

        })
    }, [dataSF]);


    React.useEffect(() => {

        dataCN?.map(x => {
                
            totalGeralCN +=  Number(x.count) 
            

            setTotalForaMapCN(totalGeralCN)

        })
    }, [dataCN]);

    const CheckEsfera = (select) => {
        switch (select) {
            case 'F':
                return 'Federal'
            case 'E':
                return 'Estadual'
            case 'M':
                return 'Municipal'
            default:
                return 'Federal'
        }
    }

    return (
        <div>
            <div className="relativeCSS">
                <style type="text/css" media="print">
                    {"\
                        @page { size: A4; }\
                    "}
                </style>
                <div className="flash" />
                <div style={{ width: '1000px', WebkitPrintColorAdjust: 'exact' }} >
                    <table className="testClass" style={{ width: '1000px' }} >
                        <thead>
                            <tr>
                                <td>
                                    <Grid container style={{
                                        padding: "20px",
                                        backgroundColor: `${pallet.general.color1}`,
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        height: '70px'
                                    }}>
                                        <Grid style={{}}>
                                            <img style={{ width: '100px' }} src={legis_agenda} />
                                        </Grid>
                                        <Grid style={{
                                            color: 'white',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size12}`
                                        }}>
                                            Monitoramento Inteligente no Poder Legislativo
                                        </Grid>
                                        <Grid>
                                            <IconButton onClick={Imprimir} style={{ color: 'white' }} aria-label="upload picture" component="span">
                                                <PrintIcon />
                                            </IconButton>
                                        </Grid>

                                    </Grid>
                                </td>
                            </tr>
                        </thead>
                        <tbody style={{
                            width: '900px',
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                            <tr>
                                <td>
                                    <Grid container style={{
                                        width: '990px',
                                        padding: '30px'
                                    }}>
                                        <Grid style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "left",
                                        }}>
                                            <img style={{ width: '100px' }} src={legis_agenda2} />
                                        </Grid>
                                        <Grid style={{ marginLeft: '50px' }}>
                                            <Grid style={{
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontSize: `${pallet.general.size16}`,
                                            }}>
                                                Relatório / {CheckEsfera(esferaTipo)}
                                            </Grid>
                                            <Grid style={{
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontSize: '20px',
                                                fontWeight: pallet.general.weight_bold,
                                                marginTop: '8px'
                                            }}>
                                                Proposições Divididas por Temas Legislativos
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </td>
                            </tr>
                            <tr >
                                <td>
                                    {loading ?
                                        <CircularLoading
                                            size={100}
                                            top={isMobile ? "37%" : "40%"}
                                            left={isMobile ? "6%" : "16%"}
                                            zIndex={2}
                                        />
                                        :
                                        <Grid style={{
                                            width: '990px',
                                            marginTop: '30px',
                                            border: `1px solid #e0e0e0`,
                                            borderRadius: '7px'
                                        }}>
                                            <Grid container>
                                                <Grid item>
                                                    <Grid style={{
                                                        borderTopLeftRadius: '7px',
                                                        borderBottomLeftRadius: '7px',
                                                        backgroundColor: `${pallet.backgroundColorQuintenary}`,
                                                        padding: '15px',
                                                        marginTop: '-1px',
                                                        width: '70px',
                                                    }}>
                                                        <CalendarTodayIcon style={{
                                                            marginTop: '3px',
                                                            marginLeft: '8px',
                                                            color: `${pallet.textColorSecondary}`
                                                        }} />
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <Grid >
                                                        <Typography
                                                            style={{
                                                                color: `${pallet.color.quinternary.font}`,
                                                                fontSize: `${pallet.general.size16}`,
                                                                fontFamily: `${pallet.fontFamily.general}`,
                                                                fontWeight: pallet.general.weight_bold,
                                                                paddingLeft: "20px",
                                                                paddingTop: '10px'
                                                            }}>
                                                            PERÍODO DE APRESENTAÇÃO
                                                        </Typography>

                                                    </Grid>
                                                    <Grid>
                                                        <Grid container>
                                                            <Grid >
                                                                <Typography
                                                                    style={{
                                                                        color: `${pallet.color.secundary.font}`,
                                                                        fontSize: `${pallet.general.size12}`,
                                                                        fontFamily: `${pallet.fontFamily.general}`,
                                                                        fontWeight: pallet.general.weight_bold,
                                                                        paddingLeft: "20px"
                                                                    }}>
                                                                    {String(format(new Date(dtIni), 'dd/MM/yyyy'))}
                                                                </Typography>

                                                            </Grid>
                                                            <Grid >
                                                                <Typography
                                                                    style={{
                                                                        color: `${pallet.color.secundary.font}`,
                                                                        fontSize: `${pallet.general.size12}`,
                                                                        fontFamily: `${pallet.fontFamily.general}`,
                                                                        fontWeight: pallet.general.weight_bold,
                                                                        paddingLeft: "5px"
                                                                    }}>
                                                                    à
                                                                </Typography>

                                                            </Grid>
                                                            <Grid >
                                                                <Typography
                                                                    style={{
                                                                        color: `${pallet.color.secundary.font}`,
                                                                        fontSize: `${pallet.general.size12}`,
                                                                        fontFamily: `${pallet.fontFamily.general}`,
                                                                        fontWeight: pallet.general.weight_bold,
                                                                        paddingLeft: "5px"
                                                                    }}>
                                                                    {String(format(new Date(dtFin), 'dd/MM/yyyy'))}
                                                                </Typography>

                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{marginTop: '70px'}}>
                                    TOTAL: {totalForaMapCD}
                                </Grid>
                                <Grid style={{
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_bold,
                                    color: `${pallet.color.secundary.font}`
                                }}>
                                    | CÂMARA
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TEMA
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataCD.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tema}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.count}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}
                    </Grid>
                    <table>
                        <tbody>
                            <tr>
                                 <Grid style={{marginTop: '70px'}}>
                                    TOTAL: {totalForaMapSF}
                                </Grid>
                                <Grid style={{
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_bold,
                                    color: `${pallet.color.secundary.font}`
                                }}>
                                    | SENADO
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TEMA
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataSF.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tema}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.count}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}


                    </Grid>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{marginTop: '70px'}}>
                                    TOTAL: {totalForaMapCN}
                                </Grid>
                                <Grid style={{
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_bold,
                                    color: `${pallet.color.secundary.font}`
                                }}>
                                    | CONGRESSO
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TEMA
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataCN.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tema}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.count}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}


                    </Grid>
                </div>
            </div>
            {/* </Grid> */}
        </div>
    );
};
